import {
    MEASUREMENT_LIST_REQUEST,
    MEASUREMENT_LIST_SUCCESS,
    MEASUREMENT_LIST_FAIL,
    MEASUREMENT_DELETE_REQUEST,
    MEASUREMENT_DELETE_SUCCESS,
    MEASUREMENT_DELETE_FAIL,
    MEASUREMENT_LIST_BY_STATUS_REQUEST,
    MEASUREMENT_LIST_BY_STATUS_SUCCESS,
    MEASUREMENT_LIST_BY_STATUS_FAIL,
  } from "../../constants/MeasurementConstants";
  
  // Measurements List Reducer
  export const measurementListReducer = (state = { measurements: [] }, action) => {
    switch (action.type) {
      case MEASUREMENT_LIST_REQUEST:
        return { loading: true, measurements: [] };
      case MEASUREMENT_LIST_SUCCESS:
        return {
          loading: false,
          measurements: action.payload.measurements,
          totalPages: action.payload.totalPages,
          currentPage: action.payload.currentPage,
        };
      case MEASUREMENT_LIST_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  // Measurement Delete Reducer
  export const measurementDeleteReducer = (state = {}, action) => {
    switch (action.type) {
      case MEASUREMENT_DELETE_REQUEST:
        return { loading: true };
      case MEASUREMENT_DELETE_SUCCESS:
        return { loading: false, success: true };
      case MEASUREMENT_DELETE_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };
  

  //reducer for quotation list
  export const QuotationListReducer = (state = { measurements: [] }, action) => {
    switch (action.type) {
      case MEASUREMENT_LIST_BY_STATUS_REQUEST:
        return { loading: true };
      case MEASUREMENT_LIST_BY_STATUS_SUCCESS:
        console.log(action.payload);
        return {
          loading: false,
          measurements: action.payload.measurements,
          totalPages: action.payload.totalPages,
        };
      case MEASUREMENT_LIST_BY_STATUS_FAIL:
        return { loading: false, error: action.payload };
      default:
        return state;
    }
  };

  //search suggestion reducer
  const suggestionList = {
    suggestions: [],
    loading: false,
    error: null,
  };
  
  export const searchSuggestionsReducer = (state = suggestionList, action) => {
    switch (action.type) {
      case 'FETCH_SUGGESTIONS_SUCCESS':
        return { ...state, suggestions: action.payload, loading: false };
      case 'FETCH_SUGGESTIONS_FAIL':
        return { ...state, error: action.payload, loading: false };
      default:
        return state;
    }
  };

    //search suggestion reducer
    const quotationSuggestion = {
      suggestions: [],
      loading: false,
      error: null,
    };
    
    export const searchQuotationSuggestion = (state = quotationSuggestion, action) => {
      switch (action.type) {
        case 'FETCH_QUOTATIONS_SUGGESTIONS_SUCCESS':
          return { ...state, suggestions: action.payload, loading: false };
        case 'FETCH_QUOTATIONS_SUGGESTIONS_FAIL':
          return { ...state, error: action.payload, loading: false };
        default:
          return state;
      }
    };